export default __webpack_public_path__ + "static/media/9.389feaa5.png";